import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as c } from "react";
const i = ({
  title: o,
  titleId: s,
  ...l
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": s,
    ...l,
    children: [
      o ? /* @__PURE__ */ e.jsx("title", { id: s, children: o }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M730.033 517.754c-38.635 0-69.973-31.147-69.973-69.76s31.339-69.973 69.973-69.973c38.613 0 69.952 31.36 69.952 69.973s-31.339 69.76-69.952 69.76m-218.048 0c-38.592 0-69.952-31.147-69.952-69.76s31.36-69.973 69.952-69.973c38.635 0 69.995 31.36 69.995 69.973s-31.36 69.76-69.995 69.76m-218.005 0c-38.613 0-69.995-31.147-69.995-69.76s31.381-69.973 69.995-69.973c38.613 0 69.76 31.36 69.76 69.973s-31.147 69.76-69.76 69.76m346.005-389.76h-256c-88.512 0-168.299 35.84-226.325 93.653-57.813 58.027-93.675 137.813-93.675 226.347 0 148.053 100.48 272.661 237.227 309.333 9.408 2.581 16.213 10.667 16.213 20.48v93.248c0 19.819 22.187 31.552 38.635 20.672L536.945 771.62c3.413-2.347 7.701-3.627 11.755-3.627h91.285c88.341 0 168.341-35.84 226.368-93.653 57.813-58.027 93.632-138.027 93.632-226.347 0-176.853-143.339-320-320-320z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), r = c(i);
export {
  r as default
};
